<div class="flex flex-column align-items-center mt-8">
  <div class="flex flex-column mb-4 align-items-center">
    <div class="text-900 text-xl font-bold mb-2">
      {{ 'VERIFICATION.emailVerification' | translate }}
    </div>
    {{ 'VERIFICATION.verifyProfileMessage' | translate }}
    <span class="text-600 font-medium"></span>
  </div>
  <div class="flex flex-column">
    <div class="flex flex-wrap gap-2 justify-content-between">
      <app-button
        (click)="resendEmail()"
        label="{{ 'VERIFICATION.resendVerification' | translate }}"
      ></app-button>
    </div>
  </div>
</div>
